export const PRODUCT_LINE_HOME_US = 'home_us';
export const PRODUCT_HOME_US_HOMEOWNERS = 'home_us_owners';
export const PRODUCT_HOME_US_RENTERS = 'home_us_renters';

export const PRODUCT_LINE_HOME_EU = 'home_eu';
export const PRODUCT_HOME_EU_CONTENTS_AND_LIABILITY = 'home_eu_contents_and_liability';
export const PRODUCT_HOME_EU_CONTENTS_ONLY = 'home_eu_contents';
export const PRODUCT_HOME_EU_LIABILITY_ONLY = 'home_eu_liability';
export const PRODUCT_HOME_EU_HOMEOWNERS = 'home_eu_owners';
export const PRODUCT_HOME_EU_RENTERS = 'home_eu_renters';

export const PRODUCT_PET = 'pet';
export const PRODUCT_LIFE = 'life';
export const PRODUCT_CAR = 'car';
export const PRODUCT_RENTERS = 'renters';
export const PRODUCT_HOME = 'home';
export const PRODUCT_NONE = 'none';

export const PRODUCT_GB_CONTENTS = 'contents';

export const Products = {
  PRODUCT_LINE_HOME_US,
  PRODUCT_HOME_US_HOMEOWNERS,
  PRODUCT_HOME_US_RENTERS,
  PRODUCT_LINE_HOME_EU,
  PRODUCT_HOME_EU_CONTENTS_AND_LIABILITY,
  PRODUCT_HOME_EU_CONTENTS_ONLY,
  PRODUCT_HOME_EU_LIABILITY_ONLY,
  PRODUCT_HOME_EU_HOMEOWNERS,
  PRODUCT_HOME_EU_RENTERS,
  PRODUCT_PET,
  PRODUCT_LIFE,
  PRODUCT_CAR,
} as const;

export type Product = (typeof Products)[keyof typeof Products];
